import providerService from "../services/provider.service";

const providers = {
    namespaced: true,
    state: {},
    actions: {
        //CREATE
        create(_, provider) {
            return providerService.create(provider);
        },

        //READ
        get(_, params) {
            return providerService.get(params.id, params.urlParameters, params.requestId);
        },
        getlist() {
            return providerService.getlist();
        },
        getlistaccicarefacilities(_, selectedProviderId) {
            return providerService.getlistaccicarefacilities(selectedProviderId);
        },
        getUserProvidersList() {
            return providerService.getUserProvidersList();
        },
        getPatientAuthorizers(_, providerId) {
            return providerService.getPatientAuthorizers(providerId);
        },
        getIncidentAuthorizers(_, providerId) {
            return providerService.getIncidentAuthorizers(providerId);
        },
        getDisciplines(_, providerId) {
            return providerService.getDisciplines(providerId);
        },
        getMedediDisciplines(_, providerId) {
            return providerService.getMedediDisciplines(providerId);
        },
        //UPDATE
        update(_, provider) {
            return providerService.update(provider);
        },

        //DELETE
        delete(_, id) {
            return providerService.delete(id);
        },

        //PROVIDER FILES
        //CREATE
        createFile(_, params) {
            return providerService.createFile(params.providerId, params.formdata);
        },
        //READ
        getFileTypes() {
            return providerService.getFileTypes();
        },
        //UPDATE
        updateFile(_, entity) {
            return providerService.updateFile(entity);
        },
        //DELETE
        deleteFile(_, params) {
            return providerService.deleteFile(params.providerId, params.providerFileId);
        },
    },
    getters: {},
    mutations: {},
};

export default providers;
